import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyB-HGSwnrtWp8hsF_te-FJWrgmkiYcEK14',
  authDomain: 'zapolyare-757d2.firebaseapp.com',
  projectId: 'zapolyare-757d2',
  storageBucket: 'zapolyare-757d2.firebasestorage.app',
  messagingSenderId: '194233952574',
  appId: '1:194233952574:web:ca47539016dc6deeb5646f',
}

firebase.initializeApp(firebaseConfig)

const firebaseSideEffect = firebase.initializeApp(
  firebaseConfig,
  'Side Effect instance'
)

const db = firebase.firestore()
const storageRef = firebase.storage().ref()
const { storage } = firebase
const functions = firebase.app().functions('europe-west3')

export { db, storage, storageRef, firebase, firebaseSideEffect, functions }
